export const SearchQA = {
    Panel: 'g-md-search-panel',
    Counter: 'g-md-search-counter',
    NextBtn: 'g-md-search-next-btn',
    PrevBtn: 'g-md-search-prev-btn',
    FindInput: 'g-md-search-find-input',
    ReplaceInput: 'g-md-search-replace-input',
    ReplaceBtn: 'g-md-search-replace-btn',
    ReplaceAllBtn: 'g-md-search-replace-all-btn',
    ExpandBtn: 'g-md-search-expand-btn',
    CaseSensitiveCheck: 'g-md-search-case-sensitive-check',
    WholeWordCheck: 'g-md-search-whole-word-check',
    CloseBtn: 'g-md-search-close-btn',
} as const;
